import { Globe, Loader2 } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger } from "@/components/ui/select";
import { useI18n } from "@/context/I18nContext";
import { LANGUAGES } from "@/i18n/strings";

export const LanguageSwitcher = ({ compact = false }) => {
  const { lang, auto, setLang, t, translating } = useI18n();
  return (
    <Select value={auto ? "auto" : lang} onValueChange={setLang}>
      <SelectTrigger data-testid="language-switcher" className={`bg-[#070912]/90 border-white/10 text-slate-200 ${compact ? "w-[52px] px-2 justify-center [&>svg:last-child]:hidden" : "w-full"}`}>
        <div className="flex items-center gap-2 min-w-0">
          {translating ? <Loader2 className="w-4 h-4 animate-spin text-[#3ad7ff] shrink-0" /> : <Globe className="w-4 h-4 text-[#3ad7ff] shrink-0" />}
          {!compact && <span className="truncate text-sm" data-testid="language-current">{auto ? "Auto · " : ""}{LANGUAGES.find((l) => l.code === lang)?.label}</span>}
        </div>
      </SelectTrigger>
      <SelectContent className="bg-[#0b0e1a] border-white/10 text-slate-200 max-h-80">
        <SelectItem value="auto" data-testid="language-option-auto">{t("nav.auto_lang")}</SelectItem>
        {LANGUAGES.map((l) => (
          <SelectItem key={l.code} value={l.code} data-testid={`language-option-${l.code}`}>{l.label}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
